// import { push } from 'react-router-redux';
// import { delay } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import formulariosService from '../../commons/services/formularios';
import { actions, types } from '../modules/formularios';
import { flow } from '../modules/flow';

export default function* formulariosSaga() {
	yield takeEvery(types.FORMULARIOS_URL_SERVICO, urlFormularioServico);
}

function* urlFormularioServico(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			console.log('Action: ', action);
			let url = yield call(formulariosService.urlFormularioServico, action.payload.codigo, action.payload.token);
			url = `${url}?access_token=${action.payload.token}`;
			console.log('Url na saga: ', url);
			yield put(actions.atualizarStore({ url }));
		},
		fnCatch: function* () {
			yield put(actions.atualizarStore({ url: null }));
		}
	});
}

